export function stringToDate(input) {
  if (!input) return new Date(1970);
  return new Date(Date.parse(input));
}

export function dateToString(input) {
  return input instanceof Date
    ? `${input.getFullYear()}-${(input.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${input.getDate().toString().padStart(2, '0')}`
    : input;
}
